import player from './player'

let textureList

const storeTextureList = function () {
  return new Promise((resolve, reject) => {
    let api = player.getApi()
    if (api) {
      api.getTextureList(function (err, theTextureList) {
        if (err) {
          console.log(err.stack)
        } else {
          textureList = theTextureList
          resolve()
        }
      })
    } else {
      reject(new Error('API not found'))
    }
  })
}

const getTextureList = function () {
  return textureList
}

const getTextureUidByName = function (textureName) {
  const result = textureList.find(tex => {
    if (tex.name === textureName) return tex.uid
  })
  return result
}

const addTexture = function (textureUrl) {
  return new Promise((resolve, reject) => {
    let api = player.getApi()
    if (api) {
      api.addTexture(textureUrl, function (err, uid) {
        if (err) {
          console.log(err)
        } else {
          resolve(uid)
        }
      })
    } else {
      reject(new Error('API not found'))
    }
  })
}

const updateTexture = function (textureUrl, textureUid) {
  return new Promise((resolve, reject) => {
    let api = player.getApi()
    if (api) {
      api.updateTexture(textureUrl, textureUid, function (err, uid) {
        if (err) {
          console.log(err.stack)
        } else {
          resolve(uid)
        }
      })
    } else {
      reject(new Error('API not found'))
    }
  })
}

const makeTexture = function (uid) {
  const texture = {
    magFilter: 'LINEAR',
    minFilter: 'LINEAR_MIPMAP_LINEAR',
    wrapS: 'REPEAT',
    wrapT: 'REPEAT',
    textureTarget: 'TEXTURE_2D',
    internalFormat: 'RGB',
    texCoordUnit: 0,
    uid: uid
  }
  return texture
}

export default { storeTextureList, getTextureList, getTextureUidByName, makeTexture, addTexture, updateTexture }
